var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgIcMilestone1Off = function SvgIcMilestone1Off(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    fill: "none",
    viewBox: "0 0 20 20"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#D8D8DF",
    stroke: "#A0A2AE",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.987,
    d: "M6.992 18.544a1.404 1.404 0 0 0 1.292-1.971l1.127-1.127a.73.73 0 0 0 0-1.03L8.284 13.29a.73.73 0 0 0-.794-.158.7.7 0 0 0-.235.158l-1.943 1.942a1.554 1.554 0 0 0 0 2.2l.69.69a1.4 1.4 0 0 0 .99.422"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#D8D8DF",
    stroke: "#A0A2AE",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.987,
    d: "M13.228 18.545c.272 0 .54-.07.777-.204l.845-.486a1.413 1.413 0 0 0-.71-2.637h-.087a7.178 7.178 0 1 0-3.03 1.088l.85 1.457a1.55 1.55 0 0 0 1.355.782"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#A0A2AE",
    stroke: "#A0A2AE",
    strokeWidth: 0.658,
    d: "M14.134 8.883a.407.407 0 1 1 0-.813.407.407 0 0 1 0 .813ZM11.15 8.883a.407.407 0 1 1 0-.813.407.407 0 0 1 0 .813Z"
  })));
};
export default SvgIcMilestone1Off;